/** Centralized route path constants */
export const ROUTES = {
  DASHBOARD: '/',
} as const;
